import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Users, Loader2, CheckCircle, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';
import { ticketService } from '../../services/api';

export const MajClientsModal = ({ open, onOpenChange, project, onSuccess }) => {
  const [rawData, setRawData] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleSubmit = async () => {
    if (!rawData.trim()) {
      toast.error('Collez les données du tableau');
      return;
    }

    setLoading(true);
    setResult(null);

    try {
      const res = await ticketService.importUpdateClientsPaste(rawData, project);
      setResult(res);
      if (res.updated > 0) {
        toast.success(`${res.updated} ticket(s) mis à jour`);
        onSuccess?.();
      } else {
        toast.warning(res.message);
      }
    } catch (err) {
      toast.error('Erreur: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setRawData('');
    setResult(null);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="max-w-2xl bg-zinc-900 border-zinc-700"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-white">
            <Users className="h-5 w-5 text-cyan-400" />
            MAJ Clients VENTE
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <p className="text-sm text-zinc-400">
            Copiez-collez les lignes depuis votre tableau (avec en-têtes).
            Les colonnes <span className="text-cyan-400 font-semibold">ORDER/REF</span> servent à retrouver les tickets VENTE.
            Les colonnes <span className="text-cyan-400 font-semibold">NAMES, SURNAMES, DOB, EMAIL</span> seront mises à jour.
          </p>

          <Textarea
            value={rawData}
            onChange={(e) => setRawData(e.target.value)}
            placeholder={"DATE\tORDER\tEVENTS\tCATEGORY\tQUANTITY\tPRICE\tINVOICE\tNAMES\tSURNAMES\tDOB\tEMAIL\n05/06/2026\tISRARENA-8\tSEMI 2\tCAT3\t1\t300\t\tJean\tDUPONT\t15/03/1990\tjean@test.com"}
            className="min-h-[200px] bg-zinc-800 border-zinc-600 text-white font-mono text-xs"
            disabled={loading}
          />

          {rawData.trim() && (
            <p className="text-xs text-zinc-500">
              {rawData.trim().split('\n').length - 1} ligne(s) de données détectée(s)
            </p>
          )}

          {result && (
            <div className="rounded-lg border border-zinc-700 p-3 space-y-1">
              <div className="flex items-center gap-2">
                {result.updated > 0 ? (
                  <CheckCircle className="h-4 w-4 text-emerald-400" />
                ) : (
                  <AlertCircle className="h-4 w-4 text-amber-400" />
                )}
                <span className="text-sm text-white font-medium">{result.message}</span>
              </div>
              {result.details?.length > 0 && (
                <div className="mt-2 max-h-32 overflow-y-auto text-xs text-zinc-400 space-y-0.5">
                  {result.details.map((d, i) => (
                    <div key={i} className={d.includes('non trouvé') ? 'text-red-400' : 'text-emerald-400'}>
                      {d}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          <div className="flex justify-end gap-3">
            <Button variant="outline" onClick={handleClose} className="border-zinc-600">
              Fermer
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={loading || !rawData.trim()}
              className="bg-cyan-600 hover:bg-cyan-500 text-white"
            >
              {loading ? (
                <><Loader2 className="h-4 w-4 mr-2 animate-spin" /> Traitement...</>
              ) : (
                <><Users className="h-4 w-4 mr-2" /> Mettre à jour</>
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
